import { render } from "./VoucherSequenceNotice.vue?vue&type=template&id=13254a6e&scoped=true"
import script from "./VoucherSequenceNotice.vue?vue&type=script&lang=js"
export * from "./VoucherSequenceNotice.vue?vue&type=script&lang=js"

import "./VoucherSequenceNotice.vue?vue&type=style&index=0&id=13254a6e&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\Erp Con api propia\\ERP CON MI-API\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13254a6e"]])

export default __exports__